import { Link } from 'react-router-dom';
import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import { Section } from 'src/app/components/Elements/Section';
import { Typography } from 'src/app/components/Elements/Typography';
import { MAX_WIDTH_CONTAINER } from 'src/consts';
import type { ThemeColorType } from 'src/styles/theme';

export const StyledLink = styled.a<{ color?: ThemeColorType }>`
  color: ${props => (props.color ? props.theme.colors[props.color] : props.theme.colors.capsuleGreen60)} !important;
`;

export const StyledSection = styled(Section)`
  padding-bottom: 2.4rem;

  ${props => props.theme.mediaQueries.smallDown} {
    padding: 7.2rem 2.4rem;
  }
`;

export const SubsectionTitle = styled(Typography)<{ small?: boolean }>`
  margin-bottom: 2.4rem !important;

  ${props => props.theme.mediaQueries.medium} {
    font-size: 2rem !important;
    line-height: 2.4rem !important;
    margin-bottom: ${props => (props.small ? '2.4rem' : '3.2rem')} !important;
  }
`;

export const FlexContent = styled.div`
  max-width: ${MAX_WIDTH_CONTAINER};
  margin: 0 auto;

  ${props => props.theme.mediaQueries.medium} {
    display: flex;
  }
`;

export const NeedHelpContent = styled.div`
  margin-bottom: 4.8rem;
`;

export const AppButtonsContent = styled.div`
  padding: 0;
`;

export const MobileAppLinks = styled.div`
  display: flex;
  margin-bottom: 4.8rem;
  flex-wrap: wrap;
  gap: 1.2rem;
  margin-right: 1.2rem;

  ${props => props.theme.mediaQueries.medium} {
    margin-bottom: 7.2rem;
  }
`;

export const MobileLink = styled.a`
  cursor: pointer;
`;

export const MobileSVG = styled(props => <InlineSVG {...props} />)`
  svg {
    width: 152px !important;
    height: 48px !important;

    @media screen and (max-width: 371px) {
      width: 120px !important;
    }
  }
`;

export const LeftContent = styled.div`
  ${props => props.theme.mediaQueries.medium} {
    flex: 0 0 40%;
    margin-right: 1.2rem;
  }
`;

export const RightContent = styled.div`
  display: flex;
  margin-bottom: 8.4rem;
  position: relative;

  ${props => props.theme.mediaQueries.medium} {
    flex: 0 0 60%;
    margin-bottom: 0;
  }
`;

export const CompanyInfoContent = styled.div`
  width: 152px;
  height: 160px;
  display: inline-block;
  margin-right: 2.4rem;

  ${props => props.theme.mediaQueries.medium} {
    flex: 1;
  }
`;

export const MoreInfoContent = styled.ul`
  list-style: none;
`;

export const Info = styled.li`
  :not(:last-of-type) {
    margin-bottom: 1.2rem;
  }

  a {
    color: ${props => props.theme.colors.capsuleGreen80} !important;
  }
`;

export const SocialMediaContent = styled.div`
  width: 152px;
  height: 160px;
  display: inline-block;

  ${props => props.theme.mediaQueries.medium} {
    flex: 2;
  }
`;

export const SocialMediaIcons = styled.div`
  padding: 0;
`;

export const MediaIconLink = styled.a`
  &:not(:first-child) {
    margin-left: 3.1rem;
  }
`;

export const MediaIcon = styled(props => <InlineSVG {...props} />)`
  svg {
    width: 24px !important;
    height: 24px !important;
  }
`;

export const Copyright = styled.div`
  margin-bottom: 7.2rem;
  display: block;

  ${props => props.theme.mediaQueries.medium} {
    max-width: ${MAX_WIDTH_CONTAINER};
    margin: 0 auto;
  }
`;

export const CopyrightLink = styled(Link)`
  color: ${props => props.theme.colors.capsuleGreen80} !important;
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  line-height: ${props => props.theme.lineHeights.small};
  display: inline-block;

  &:not(:last-of-type):after {
    content: '\\007C';
    color: ${props => props.theme.colors.capsuleGray50};
    margin: 0 0.6rem;
    display: inline-block;
  }
`;

export const CopyrightLinkV2 = styled.a`
  color: ${props => props.theme.colors.capsuleGreen80} !important;
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  line-height: ${props => props.theme.lineHeights.small};
  display: inline-block;

  &:not(:last-of-type):after {
    content: '\\007C';
    color: ${props => props.theme.colors.capsuleGray50};
    margin: 0 0.6rem;
    display: inline-block;
  }
`;

export const PillSVG = styled(InlineSVG)`
  display: none;

  ${props => props.theme.mediaQueries.medium} {
    display: block;
    position: absolute;
    bottom: -215px;
    right: 50px;

    svg {
      width: 120%;
      height: 120%;

      * {
        fill: ${props => props.theme.colors.capsuleRed};
      }
    }
  }
`;
